import { render, staticRenderFns } from "./CRError.vue?vue&type=template&id=1227d944&scoped=true"
import script from "./CRError.vue?vue&type=script&setup=true&lang=js"
export * from "./CRError.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CRError.vue?vue&type=style&index=0&id=1227d944&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1227d944",
  null
  
)

export default component.exports